import React from 'react';
import { ReactComponent as CloseIcon } from '../../../shared/icons/close-icon.svg';
import './mobile-approval-header.scss';

interface MobileApprovalHeaderProps {
  onClose?: () => void;
  title: string;
  actions: React.ReactNode; // The approval dropdown will be passed as children
}

export const MobileApprovalHeader: React.FC<MobileApprovalHeaderProps> = ({ onClose, title, actions }) => {
  const handleCloseClick = () => {
    onClose?.();
  };

  return (
    <header className="mobile-approval-header" data-testid="mobile-approval-header">
      {/* Single row: Close button, centered title, and actions */}
      <div className="mobile-approval-header__row">
        <button
          type="button"
          onClick={handleCloseClick}
          className="mobile-approval-header__close-btn"
          data-testid="mobile-approval-header__close"
          aria-label="Close document"
        >
          <CloseIcon className="mobile-approval-header__close-icon" />
        </button>

        <h1 className="mobile-approval-header__title" title={title}>
          {title}
        </h1>

        <div className="mobile-approval-header__actions">{actions}</div>
      </div>
    </header>
  );
};
